/** @format */

import { CsvImportPreviewTable } from "../../components/CsvImportPreviewTable";

export const AdminDryRunPage = () => {
	return (
		<div>
			<CsvImportPreviewTable />
		</div>
	);
};
